module.exports = __webpack_public_path__ + "./Kate2_f6eb8e27d62bba35f53e00a5e8fc2592.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Kate2.png
// module id = 567
// module chunks = 0